/** @jsxImportSource @emotion/react */
import { Button } from "react-bootstrap";
import { SalesPolicyFa } from "../divisions/SalesPolicyFa";
import { SalesPolicySsnb } from "../divisions/SalesPolicySsnb";
import { SalesPolicyTest } from "../divisions/SalesPolicyTest";
import { SalesPolicyFaep } from "../divisions/SalesPolicyFaep";

interface Props {
  hasLinkButton: boolean;
  linkTitle?: string;
  linkUrl?: string;
  setIsSalesPolicyOpen?: (isSalesPolicyOpen: boolean) => void;
}

const SalesPolicy = ({ hasLinkButton, linkTitle, linkUrl, setIsSalesPolicyOpen }: Props) => {
  const baseCode = process.env.REACT_APP_CODE;
  
  return (
    <>
      <div className="scrollWrap">
        {baseCode === 'financial-agency' && (
          <SalesPolicyFa />
        )}
        {baseCode === 'ssnb' && (
          <SalesPolicySsnb />
        )}
        {baseCode === 'test' && (
          <SalesPolicyTest />
        )}
        {baseCode === 'faep' && (
          <SalesPolicyFaep />
        )}
      </div>
      {hasLinkButton && (
        <div className="linkButton">
          <Button
            href={linkUrl}
            target="_blank"
            className="netBtn buttonIcon buttonRadius"
            variant="orange"
            onClick={() => {
              if (setIsSalesPolicyOpen !== undefined){
                setIsSalesPolicyOpen(false);
              }
            }}
          >
            {linkTitle}
            <span className="sub">保険会社サイトへ</span>
          </Button>
        </div>
      )}
    </>
  );
};
export default SalesPolicy;
